import { render, staticRenderFns } from "./BackLogin.vue?vue&type=template&id=5f31745e&"
import script from "./BackLogin.vue?vue&type=script&lang=js&"
export * from "./BackLogin.vue?vue&type=script&lang=js&"
import style0 from "./BackLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports